/**
 * Job 삭제 mutation 훅.
 *
 * 성공 시 jobs 목록 캐시를 무효화하여 즉시 사라지도록 한다. 또한 혹시
 * 사용자가 보고 있던 ``/jobs/{id}`` 상세 캐시도 함께 제거 — 외부 라우터
 * 가드가 없어 backforward 시 stale 데이터를 보지 않도록 안전망.
 *
 * 타입 주석에 ``useMutation<void, ...>`` 를 명시하지 않고 ``mutationFn``
 * 인자 타입으로 추론에 맡긴다. ESLint 의 ``no-invalid-void-type`` 룰이
 * ``useMutation`` generic 자리에 직접 쓰인 ``void`` 를 금지하기 때문.
 */

import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteJob } from "@/lib/api/jobs";

import { JOBS_QUERY_KEY } from "./useJobs";
import { jobDetailKey } from "./useJobDetail";

export function useDeleteJob() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (jobId: string) => deleteJob(jobId),
    onSuccess: (_data, jobId) => {
      qc.invalidateQueries({ queryKey: JOBS_QUERY_KEY });
      qc.removeQueries({ queryKey: jobDetailKey(jobId) });
    },
  });
}
